import { useEffect } from "react";
import api from "@/lib/api";

const BASE = "https://www.estemsurucukursu.com";

const STATIC_SCHEMA = {
  "@context": "https://schema.org",
  "@type": ["DrivingSchool", "LocalBusiness"],
  "name": "Estem Sürücü Kursu",
  "alternateName": "Estem Ehliyet Kursu Gebze",
  "url": BASE,
  "logo": `${BASE}/estem-logo.png`,
  "image": `${BASE}/hero-estem.jpg`,
  "description": "1989'dan beri Gebze ve Kocaeli'nde B, A1, A2, A sınıfı ehliyet kursları. 33.000+ mezun, %87 sınav başarısı, MEB onaylı belge numarası 99942149.",
  "foundingDate": "1989",
  "telephone": "+902626463646",
  "email": "info@estemsurucukursu.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Hacıhalil Mahallesi Zübeyde Hanım Caddesi Gümgüm İş Merkezi Kat:1",
    "addressLocality": "Gebze",
    "addressRegion": "Kocaeli",
    "postalCode": "41400",
    "addressCountry": "TR"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 40.8017,
    "longitude": 29.4310
  },
  "hasMap": "https://goo.gl/maps/prHGbUQpr71FUoAv7",
  "openingHoursSpecification": [
    { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "09:00", "closes": "19:00" },
    { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Saturday"], "opens": "09:00", "closes": "18:00" }
  ],
  "priceRange": "₺₺",
  "currenciesAccepted": "TRY",
  "paymentAccepted": "Cash, Credit Card, Bank Transfer",
  "areaServed": [
    { "@type": "City", "name": "Gebze" },
    { "@type": "City", "name": "Darıca" },
    { "@type": "City", "name": "Çayırova" },
    { "@type": "City", "name": "Dilovası" },
    { "@type": "City", "name": "Körfez" }
  ],
  "sameAs": [
    "https://www.google.com/maps/place/Gebze+Estem+S%C3%BCr%C3%BCc%C3%BC+Kursu",
    "https://mebbis.meb.gov.tr/ookkarekod.aspx?kkod=299832501"
  ]
};

const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Estem Sürücü Kursu",
  "url": BASE,
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${BASE}/sss?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

export default function LocalBusinessSchema() {
  useEffect(() => {
    // Inject static schemas immediately
    [
      { id: "ld-localbusiness", data: STATIC_SCHEMA },
      { id: "ld-website", data: WEBSITE_SCHEMA },
    ].forEach(({ id, data }) => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement("script");
        el.id = id;
        el.type = "application/ld+json";
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
    });

    // Fetch Google Reviews and inject AggregateRating dynamically
    api.get("/google-reviews").then(r => {
      const { rating, user_ratings_total } = r.data;
      if (!rating || !user_ratings_total) return;
      const schema = {
        ...STATIC_SCHEMA,
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": rating,
          "bestRating": "5",
          "worstRating": "1",
          "ratingCount": user_ratings_total,
          "reviewCount": user_ratings_total
        }
      };
      const el = document.getElementById("ld-localbusiness");
      if (el) el.textContent = JSON.stringify(schema);
    }).catch(() => {
      // fallback: use known values
      const schema = {
        ...STATIC_SCHEMA,
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "5.0",
          "bestRating": "5",
          "worstRating": "1",
          "ratingCount": 568,
          "reviewCount": 568
        }
      };
      const el = document.getElementById("ld-localbusiness");
      if (el) el.textContent = JSON.stringify(schema);
    });

    return () => {
      ["ld-localbusiness", "ld-website"].forEach(id => {
        document.getElementById(id)?.remove();
      });
    };
  }, []);

  return null;
}
